import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function Terms() {
  return (
    <>
    <Navigation/>
    <div className="container">
    <div className="entry-content wp-block-post-content has-global-padding is-layout-constrained wp-block-post-content-is-layout-constrained">
        <p>Sist oppdatert: 11. januar 2025</p>

        <p>Vennligst les disse Bruksvilkårene ("Vilkår", "Bruksvilkår") nøye før du bruker nettstedet https://norgesocialge.com (“Tjenesten”) som drives av https://norgesocialge.com ("vi", "vårt" eller "oss").</p>

        <p>Din tilgang til og bruk av Tjenesten er betinget av at du godtar og overholder disse Vilkårene. Disse Vilkårene gjelder for alle besøkende, brukere og andre som får tilgang til eller bruker Tjenesten.</p>

        <p>Ved å bruke Tjenesten samtykker du i å være bundet av disse Vilkårene. Hvis du er uenig i noen del av vilkårene, skal du ikke bruke Tjenesten.</p>

        <p>Før du laster ned applikasjonen vår, ber vi deg lese våre Bruksvilkår. Ved å laste ned og bruke applikasjonen vår, samtykker du i følgende:</p>

        <ul>
            <li>Du har lest og forstått våre Bruksvilkår.</li>
            <li>Du godtar å bruke Tjenesten på en lovlig måte.</li>
            <li>Du samtykker til behandlingen av dine personopplysninger i samsvar med vår personvernerklæring.</li>
        </ul>

        <p>Du har gjennomgått og akseptert våre regler for Ansvarlig Spilling.</p>

        <h2 className="wp-block-heading">Viktige Bestemmelser</h2>

        <p>1.1. Disse Bruksvilkårene fastsetter reglene for bruk av de interaktive tjenestene ("Tjenester") som tilbys av tjenesteleverandøren gjennom den nettbaserte plattformen https://norgesocialge.com ("Tjenesten").</p>

        <p>1.2. Tjenesteleverandørens tjenester gir registrerte brukere ("Deltakere") tilgang til en digital underholdningsplattform. Brukere kan samhandle, utveksle informasjon og diskutere spillrelaterte emner.</p>

        <p>1.3. Innenfor de tilgjengelige tjenestene kan deltakere ta del i spill hvor interaktive elementer gir en underholdende opplevelse. Disse spillene er utelukkende ment for fritidsformål.</p>

        <p>1.4. Bruk av tjenestene som tilbys gjennom Tjenesten og søknad om medlemskap i Tjenesten innebærer en erkjennelse og aksept av vilkårene fastsatt i dette dokumentet. Brukere som får tilgang til Tjenesten uten å registrere seg som deltakere, må også overholde disse Bruksvilkårene.</p>

        <p>1.5. Tjenesteleverandøren inngår ingen individuelle avtaler med brukerne av Tjenesten eller deltakerne. Alle brukere av tjenestene som tilbys gjennom Tjenesten, må overholde disse Bruksvilkårene.</p>

        <p>1.6. Full utnyttelse av alle funksjoner i spillene som er tilgjengelige gjennom Tjenesten, avhenger av den tekniske kompatibiliteten til brukerens datamaskin eller mobile enhet.</p>

        <p>1.7. Tjenesteleverandøren er ikke ansvarlig for manglende tilgjengelighet av Tjenesten på grunn av faktorer utenfor deres kontroll eller uforutsette omstendigheter.</p>

        <h2 className="wp-block-heading">Ansvarlig Spilling</h2>

        <p>Hovedmålet med vår nettbaserte tjeneste er å tilby underholdning til brukerne og skape et sosialt fellesskap rundt spill. Vi ønsker at alle brukere skal benytte våre tjenester for denne hensikten. For enkelte brukere kan imidlertid tidsbruken bli høyere enn ønsket. Selv om slike tilfeller er sjeldne, kan de unngås ved å følge disse grunnleggende retningslinjene:</p>

        <ul>
            <li>Spill for underholdningens skyld.</li>
            <li>Forstå at poeng og resultater kun er en del av den virtuelle spillopplevelsen.</li>
            <li>Fokuser på opplevelsen, ikke på resultater.</li>
            <li>Unngå å spille hvis du føler deg trist, sliten eller frustrert.</li>
        </ul>

        <h2 className="wp-block-heading">Kontakt Oss</h2>

        <p>Hvis du har spørsmål om disse Bruksvilkårene, vennligst kontakt oss.</p>
    </div>
</div>

    <Footer/>
    </>
  )
}

export default Terms